export default "__VITE_ASSET__BIKM1YDf__"